
import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'
import type { PropType } from 'vue'
import type { RoleAssignmentConditionMessages } from '../../models'
import type { RoleAssignmentAnyConditionOption } from './role-assignment-any-condition.component.vue'
import { defineComponent, getCurrentInstance } from 'vue'
import { mapGetters } from '../../composables/utils'
import { ColorEnum } from '../../enums'
import { CONFIG_CONSTS } from '../../store/config/config.consts'
import { UiTooltip } from '../keen-ui'
import { EpbBadge } from '../shared/epb-badge'
import { EpbText } from '../shared/epb-text'
import RoleAssignmentAnyCondition from './role-assignment-any-condition.component.vue'

export default defineComponent({
  name: 'RoleAssignmentInstanceCondition',
  components: {
    EpbBadge,
    EpbText,
    RoleAssignmentAnyCondition,
    UiTooltip,
  },
  props: {
    options: {
      type: Array as PropType<Array<RoleAssignmentAnyConditionOption>>,
      required: true,
    },
    value: {
      type: String,
      default: undefined,
    },
    allowSelectAll: {
      type: Boolean,
      default: false,
    },
    nowrap: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String as PropType<'sm' | 'md'>,
      default: 'md',
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    messages: {
      type: Object as PropType<RoleAssignmentConditionMessages>,
      default: () => ({}),
    },
  },
  emits: {
    input: (value: string) => {},
  },
  setup() {
    const ctx = getCurrentInstance()
    if (!ctx) {
      throw new Error("'ctx' is not defined")
    }

    const { instances } = mapGetters<Array<Instance>>(ctx.proxy.$store, CONFIG_CONSTS.moduleName, {
      instances: CONFIG_CONSTS.getters.instances,
    })

    const COLLAPSED_OPTIONS = 5

    const baseClass = 'epb-role-assignment-instance-condition'

    function getInstance(value: string): Instance | undefined {
      return instances.value.find(instance => instance.id === value)
    }

    function getOptionImage(value: string): string {
      const instance = getInstance(value)
      return (
        instance?.logoUrls?.isotype ||
        instance?.logoUrls?.imagotype ||
        require('../../assets/media/image/image-not-found.svg')
      )
    }

    function getOptionLabel(value: string): string {
      return getInstance(value)?.prettyName || value
    }

    return {
      COLLAPSED_OPTIONS,
      baseClass,
      getOptionImage,
      getOptionLabel,
      ColorEnum,
    }
  },
})
